import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile?: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    activityLogList: {
      padding: 0,
      ...(!isLayoutMobile && {
        maxHeight: '16rem',
        overflowY: 'auto'
      })
    },
    activityLogListItem: {
      height: '42px',
      padding: 0,
      '&::after': {
        content: '""',
        width: 0,
        height: '0.5rem',
        border: `.025rem solid ${theme.vars.palette.border.main}`,
        left: '0.813rem',
        bottom: 0,
        position: 'absolute',
        transform: 'translate(50%, 50%)'
      },
      '&:last-child': {
        '&::after': {
          display: 'none'
        }
      }
    },
    activityLogListItemAvatar: {
      display: 'flex',
      borderRadius: '50%',
      marginRight: theme.spacing(1),
      minWidth: 0,
      '& .MuiAvatar-circular': {
        backgroundColor: theme.vars.palette.transparent.a10,
        border: `1px solid ${theme.vars.palette.border.light}`,
        color: theme.vars.palette.transparent.a50,
        svg: {
          height: '0.75rem'
        }
      }
    },
    activityLogAvatar: {
      height: 28,
      width: 28
    },
    activityLogListItemText: {
      margin: 0,
      '& .MuiTypography-body1': {
        color: theme.vars.palette.text.primary,
        fontSize: '0.75rem',
        lineHeight: '0.875rem'
      },
      '& .MuiTypography-body2': {
        color: theme.vars.palette.transparent.a50,
        fontSize: '0.6875rem',
        lineHeight: '0.75rem'
      }
    }
  }));

export default useStyles;
